import React from 'react';

const ContactFilterBar = ({ filter, onFilterChange }) => {
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'new', label: 'New' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'closed', label: 'Closed' },
  ];

  return (
    <div className="p-4 border-b border-gray-200" data-testid="contact-filter-bar">
      <div className="flex gap-4">
        {filters.map((f) => (
          <button
            key={f.value}
            onClick={() => onFilterChange(f.value)}
            data-testid={`filter-${f.value}`}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              filter === f.value
                ? 'bg-amber-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContactFilterBar;
